var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.producto.producto_nombre))]),_c('td',[_vm._v(_vm._s(_vm.producto.stock_total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }